export type PaymentTabSlug = 'payins' | 'payouts' | 'items' | 'transfers';

export interface PaymentTab {
  slug: PaymentTabSlug;
  label: string;
  // preserve hiding for GBR
  hiddenForGBR?: boolean;
  /** Only shown when the subWallets feature flag is on. */
  requiresSubWallets?: boolean;
}

export const PAYMENT_TABS: PaymentTab[] = [
  { slug: 'payins', label: 'Payins' },
  { slug: 'payouts', label: 'Payouts' },
  { slug: 'items', label: 'Items', hiddenForGBR: true },
  { slug: 'transfers', label: 'Transfers', requiresSubWallets: true },
];

interface VisibleTabsOptions {
  locale: string;
  subWalletsEnabled: boolean;
}

export function visiblePaymentTabs({
  locale,
  subWalletsEnabled,
}: VisibleTabsOptions): PaymentTab[] {
  return PAYMENT_TABS.filter((tab) => {
    if (tab.hiddenForGBR && locale === 'en-GB') return false;
    if (tab.requiresSubWallets && !subWalletsEnabled) return false;
    return true;
  });
}
